import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { TbPalette } from "react-icons/tb";
import { defaultTheme, getClientTheme, setClientTheme } from "src/store/slices/client";
import { applyThemeTokens } from "src/utility";

const ALT_THEME = { primaryColor: "#871e35", secondaryColor: "#c8a15a" };

let previousTheme = defaultTheme;

const ThemeSwitch: FC<{ className?: string }> = ({ className }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const clientTheme = useSelector(getClientTheme);
  const isAlt = clientTheme.primaryColor === ALT_THEME.primaryColor && clientTheme.secondaryColor === ALT_THEME.secondaryColor;

  const onClick = () => {
    if (!isAlt) previousTheme = clientTheme;
    const nextTheme = isAlt ? previousTheme : ALT_THEME;
    applyThemeTokens(nextTheme);
    dispatch(setClientTheme(nextTheme));
  };

  return (
    <button type="button" className={className} onClick={onClick}>
      <span className="flex h-4 w-4 items-center justify-center">
        <TbPalette className="h-4 w-4" />
      </span>
      {t(isAlt ? "Menu.defaultTheme" : "Menu.altTheme")}
    </button>
  );
};

export default ThemeSwitch;
